<template>
    <div class="commodity">
        <div class="title">商品中心</div>
        <div class="main mr40">
            <el-form :inline="true" class="demo-form-inline">
                <!-- <el-form-item v-if="activeName != 'all'" label="商品类型：">
                    <el-select v-model="leix" placeholder="请选择分类类型" clearable>
                        <el-option label="虚拟商品" value="2001"></el-option>
                        <el-option label="实物商品" value="2000"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="商品ID：">
                    <el-input v-model="productId" clearable placeholder="请输入商品ID"></el-input>
                </el-form-item>
                <el-form-item label="商品名称：">
                    <el-input v-model="productName" clearable placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="商品标准基库ID">
                    <el-input v-model="standard_id" clearable placeholder="请输入商品标准基库ID"></el-input>
                </el-form-item>
                <!-- <el-form-item label="商品分类：">
                    <el-cascader
                        placeholder="请选择分类"
                        clearable
                        :props="{ value: 'id', label: 'name', multiple: true, expandTrigger: 'hover' }"
                        :options="customers"
                        collapse-tags
                        @change="selChange"
                    ></el-cascader>
                </el-form-item> -->
                <el-form-item label="审核状态：">
                    <el-select v-model="status" placeholder="请选择审核状态" @change="statusChange">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="待审核" :value="1"></el-option>
                        <el-option label="审核通过" :value="2"></el-option>
                        <el-option label="审核拒绝" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存：">
                    <div style="display: flex">
                        <el-input v-model="merchandise_inventory[0]" clearable style="width: 160px" oninput="value=value.replace(/[^\d]/g,'')"></el-input> <span style="margin: 0 8px">-</span>
                        <el-input v-model="merchandise_inventory[1]" clearable style="width: 160px" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="销售价：">
                    <div style="display: flex">
                        <el-input
                            v-model="prices_mains[0]"
                            clearable
                            style="width: 160px"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                        >
                            <template slot="append">元</template></el-input
                        >
                        <span style="margin: 0 8px">-</span>
                        <el-input
                            v-model="prices_mains[1]"
                            clearable
                            style="width: 160px"
                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                        >
                            <template slot="append">元</template></el-input
                        >
                    </div>
                </el-form-item>
                <el-form-item class="mr20">
                    <el-button @click="init">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="rufsh">搜索</el-button>
                </el-form-item>
              <!--   <el-form-item>
                    <el-button type="warning" @click="selectActivity" v-if="activeName != 'all'">添加到活动</el-button>
                </el-form-item> -->
            </el-form>
            <div class="table">
                <el-button type="primary" @click="addProduct" size="small">添加商品</el-button>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="已上架" name="sj">
                        <product
                            ref="pro"
                            v-if="activeName == 'sj'"
                            :key="inits"
                              :activeName='activeName'
                            :leix="leix"
                            :prices_mains="prices_mains"
                            :merchandise_inventory="merchandise_inventory"
                            :customer="customer"
                            :titles="productName"
                            :productId="productId"
                            @Operation="Operation"
                            :isAll="false"
                            @productDetail="productDetail"
                            @selectSpu="selectSpu"
                            :skuData="skuData"
                            @init="init"
                            @selectActivity="selectActivity"
                            :standard_id="standard_id"
                        />
                    </el-tab-pane>
                    <el-tab-pane label="商品库" name="all">
                        <product
                            ref="pro"
                            v-if="activeName == 'all'"
                            :activeName='activeName'
                            :key="inits"
                            :leix="leix"
                            :prices_mains="prices_mains"
                            :merchandise_inventory="merchandise_inventory"
                            :customer="customer"
                            :productId="productId"
                            :titles="productName"
                            @Operation="Operation"
                            :isAll="true"
                            :status="status"
                            :standard_id="standard_id"
                        />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- <el-dialog title="添加商品" :visible.sync="insertVisible" width="1024px">
            <insert :warehouseList="warehouseList" v-if="insertVisible" @showDeliveryAddress="showDeliveryAddress" @insertOk="insertOk" />
        </el-dialog>
        <el-dialog title="商品详情" :visible.sync="proDetails" width="1024px">
            <detailpro v-if="proDetails" :warehouseList="warehouseList" :ids="detailsId" @detailsOk="detailsOk" />
        </el-dialog>
        <el-dialog title="编辑商品" :visible.sync="proUpdate" width="1024px">
            <update v-if="proUpdate" :warehouseList="warehouseList" @showDeliveryAddress="showDeliveryAddress" :ids="updateid" @updateOk="updateOk" />
        </el-dialog>
        <DeliveryAddress ref="refDeliveryAddress" @initOption="getOptionList"></DeliveryAddress> -->
        <SelActivity ref="refSelActivity" @setProductShow="setProductShow" :oneData="oneData" :manyData="manyData" :skuData="skuData"></SelActivity>
        <SetProduct ref="refSetProduct" @initList="initList"></SetProduct>
        <ProductDetail ref="refProductDetail" @postProduct="postProduct" :skuData="skuData"></ProductDetail>
    </div>
</template>
<script>
import product from "./component/product";
import insert from "./component/insert";
import detailpro from "./component/details";
import update from "./component/update";
import SelActivity from "./component/selActivity";
import SetProduct from "./component/setProduct";
import { mapActions, mapGetters } from "vuex";
import DeliveryAddress from "./component/DeliveryAddress.vue";
import ProductDetail from "./component/ProductDetail.vue";
export default {
    data() {
        return {
            activeName: "sj",
            productName: "",
            customer: [],
            customers: [],
            leix: "2000",
            insertVisible: false,
            proDetails: false,
            detailsId: "",
            proUpdate: false,
            updateid: "",
            inits: 1,
            status: null,
            warehouseList: [],
            merchandise_inventory: [], //库存
            prices_mains: [], // 销售价
            oneData: [],
            manyData: [],
            skuData: [],
            productId: "",
            yearGoods: [],
            activitys_mains_id: "",
            year_type: "",
            standard_id:''
        };
    },
    components: {
        product,
        insert,
        detailpro,
        update,
        DeliveryAddress,
        SelActivity,
        SetProduct,
        ProductDetail,
    },
    created() {
        //this.getOptionList();
        this.leixChange();
       // this.getYearParams();
    },
    computed: {
        ...mapGetters(["getIsAllinUser"]),
        ...mapGetters(["getRegisterUrl"]),
    },
    methods: {
        ...mapActions({
            getGoodLei: "commodity/getGoodLei",
            deletePro: "commodity/newGoodsDelete",
            getWarehouseList: "brand/getWarehouseList",
            yearGoodsActivity: "detect/yearGoodsActivity",
            activityName: "detect/activityName",
        }),
 /*        getYearParams() {
            this.activityName({ token: this.$store.state.token }).then(({ data }) => {
                if (data.code == 1) {
                    console.log('详情 :>> ',data);
                    this.activitys_mains_id = data.data.id;
                    this.year_type = data.data.type;
                }
            });
        }, */
     /*    yearActive() {
            let arr = [...this.skuData, ...this.yearGoods];
            let arr1 = [];
            arr.forEach((item) => {
                arr1.push({
                    goods_mains_id: item.id || item.spuId,
                    goods_sku_id: item.skuId || 0,
                });
            });
            let params = {
                token: this.$store.state.token,
                goods: arr1,
                activitys_mains_id: this.activitys_mains_id, //活动id
                type: this.year_type, // 活动类型
            };
            this.yearGoodsActivity(params).then(({ data }) => {
                if (data.code == 1) {
                    this.$message.success("参加年货节成功");
                    this.$refs.pro.updateTree();
                    this.initList();
                } else {
                    this.$message.error(data.msg);
                }
            });
        }, */
        setProductShow(info, arr, type) {
            this.$refs.refSetProduct.activity_type = type;
            this.$refs.refSetProduct.dialogVisible = true;
            this.$refs.refSetProduct.bindData(JSON.parse(JSON.stringify(info)), arr);
        },
        selectSpu(arr) {
            this.oneData = [];
            this.manyData = [];
            this.yearGoods = arr;
            arr.forEach((item) => {
                let obj = {
                    spuId: item.id,
                    skuId: 0,
                };
                if (item.goods_specifications_type_id == 1) {
                    this.oneData.push(obj);
                } else {
                    this.manyData.push(obj);
                }
            });
        },
        postProduct(id, arr) {
            this.skuData = this.skuData.filter((val) => {
                return val.spuId != id;
            });
            arr.forEach((item) => {
                let obj = {
                    spuId: id,
                    skuId: item.id,
                };
                this.skuData.push(obj);
            });
            this.$refs.pro.updateTree();
        },
        productDetail(id) {
            this.$refs.refProductDetail.dialogVisible = true;
            this.$refs.refProductDetail.getList(id);
        },
        selectActivity(data) {

   let arr =   data.map((item)=>  item.spu_id)
           this.$refs.refSelActivity.dialogVisible = true;
           this.$refs.refSelActivity.checkids = arr.join(',')
           //this.$refs.refSelActivity.getSkuList(arr.join(',')) 
          
        },
        getOptionList() {
            let params = {
                token: this.$store.state.token,
            };
            this.getWarehouseList(params).then(({ data }) => {
                if (data.code == 1) {
                    this.warehouseList = data.data.list;
                } else {
                  //  this.$message.error(data.msg);
                }
            });
        },
        showDeliveryAddress() {
            this.$refs.refDeliveryAddress.dialogVisible = true;
            this.$refs.refDeliveryAddress.getList();
        },
        addProduct() {
         this.$router.push({
                path: "/home/goodsOpeation",
                query: {
                    type: "add",
                },
            }); 
            return;
            if (this.getIsAllinUser == 0) {
                this.$confirm("未注册通联支付,是否前往注册？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        if (this.getRegisterUrl) {
                            window.open(this.getRegisterUrl);
                        } else {
                            this.$router.push("/home/account");
                        }
                    })
                    .catch(() => {});
            } else {
                this.$router.push({
                    path: "/home/goodsOpeation",
                    query: {
                        type: "add",
                    },
                });
            }
        },
        selChange(val) {
            this.customer = val.map((v) => {
                return v[v.length - 1];
            });
            console.log(this.customer);
        },
        statusChange(val) {
            // console.log(this.status);
            this.$refs.pro.Bind(0);
        },
        detailsOk() {
            this.proDetails = false;
        },
        insertOk(val) {
            if (val == 1) {
                this.$refs.pro.Bind(0);
            }
            this.insertVisible = false;
        },
        updateOk(val) {
            if (val == 1) {
                this.$refs.pro.Bind(0);
            }
            this.proUpdate = false;
        },
        Operation(val) {
            switch (val.type) {
                case 1: {
                    //详情
                    // this.detailsId = parseInt(val.id);
                    // // console.log(val.id, "val.id", this.detailsId);
                    // this.proDetails = true;

                    this.$router.push({
                        path: "/home/goodsOpeation",
                        query: {
                            type: "detail",
                            id: val.id,
                        },
                    });
                    break;
                }
                case 2: {
                    //编辑
                    // this.updateid = parseInt(val.id);
                    // // console.log(val.id, "val.id", this.updateid);
                    // this.proUpdate = true;

                    this.$router.push({
                        path: "/home/goodsOpeation",
                        query: {
                            type: "edit",
                            id: val.id,
                        },
                    });
                    break;
                }
                case 3: {
                    //删除
                    const loading = this.$loading({
                        lock: true,
                        text: "Loading",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                    });
                    this.deletePro({
                        token: this.$store.state.token, //必填  商户登录后的token
                        id: parseInt(val.id), //商品表id
                    }).then((res) => {
                        loading.close();
                        if (res.code == 1) {
                            this.$refs.pro.Bind();
                            this.$message.success("删除成功！");
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                    break;
                }
            }
        },
        leixChange() {
            this.getGoodLei({
                token: this.$store.state.token,
                classifys_type_id: parseInt(this.leix),
            }).then((res) => {
                if (res.code == 1) {
                    this.customers = res.data.treeData;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        rufsh() {
            if (this.merchandise_inventory[0] > this.merchandise_inventory[1]) {
                return this.$message.warning("请输入正确的库存");
            }
            if (this.prices_mains[0] > this.prices_mains[1]) {
                return this.$message.warning("请输入正确的销售价");
            }
            this.$refs.pro.Bind(0);
        },
        initList() {
            this.manyData = [];
            this.oneData = [];
            this.skuData = [];
            this.yearGoods = [];
            this.leix = "2000";
            this.status = 0;
            this.customer.splice(0, this.customer.length);
            this.productName = "";
            this.inits++;
            this.merchandise_inventory = []; //库存
            this.prices_mains = []; // 销售价
            this.$refs.pro.Bind();
        },
        init() {
            this.manyData = [];
            this.oneData = [];
            this.skuData = [];
            this.leix = "2000";
            this.status = 0;
            this.customer.splice(0, this.customer.length);
            this.productName = "";
            this.yearGoods = [];
            this.inits++;
            this.merchandise_inventory = []; //库存
            this.prices_mains = []; // 销售价
            this.$refs.pro.Bind(0);
        },
        handleClick(tab, event) {
            this.leix = "2000";
            this.customer.splice(0, this.customer.length);
            this.productName = "";
        },
    },
};
</script>
<style lang='scss' scoped>
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 18px;
    color: #333;
    width: 100%;
    padding: 15px 32px;
}
::v-deep .el-tabs__item {
    padding: 0 42px !important;
}
::v-deep .el-tabs__active-bar {
    width: 126px !important;
    left: -43px;
}
.main {
    box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
    background: #fff;
    margin: 24px;
    padding: 30px;
    padding-bottom: 70px;
    min-width: 1200px;
    span {
        margin-right: 10px;
        ::v-deep .el-input {
            width: 300px;
            display: inline-block;
        }
    }
    .el-cascader {
        ::v-deep .el-input {
            width: 320px !important;
        }
    }
}
.table {
    position: relative;
    .el-button {
        position: absolute;
        left: 300px;
        top: 0px;
        z-index: 1;
    }
}
.main {
    .el-form {
        display: flex;
        flex-wrap: wrap;
    }
}
.mr40 {
    .el-form-item {
        margin-right: 40px;
    }
    .mr20 {
        margin-right: 10px;
    }
}
</style>
